import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { ReactNode, useCallback, useState } from "react";
import { useAPI } from "../../api/useAPI";

type ConfirmCallback = () => Promise<{ error: string } | { success: string }>;

interface Props {
  handleClose: () => void;
  handleConfirm: ConfirmCallback;
  open: boolean;
  title: string;
  children: ReactNode;
}

export const ConfirmModal = ({
  handleClose,
  handleConfirm,
  open,
  title,
  children,
}: Props) => {
  const [error, setError] = useState("");
  const [succesMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const clickSubmit = useCallback(() => {
    setLoading(true);
    setError("");
    handleConfirm()
      .then((res) => {
        if ("error" in res) {
          setError(res.error);
        }

        if ("success" in res) {
          setSuccessMessage(res.success);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {children}
        {loading === true && (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {error !== "" && <Typography color="error">{error}</Typography>}
        {succesMessage !== "" && (
          <Typography color="success">{succesMessage}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button type="submit" onClick={clickSubmit} disabled={loading}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
